module.exports = __webpack_public_path__ + "static/media/bg1.9694680d.jpg";